import React from "react";
import { Button } from "@mui/material";
import Stack from '@mui/material/Stack';

import { styled } from '@mui/material/styles';

// import Dialog from '@mui/material/Dialog';
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

// import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import "./style.css";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        width: '40%', // Set width to 80% of the screen
        maxWidth: 'none', // Remove the default maxWidth constraint
        minHeight: '250px'
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        borderTop: "0px",
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


const InnoflexSaveModal: React.FC = (props) => {
    // @ts-ignore
    let open = props.open

    return (
        <>

            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <IconButton
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#fff',
                        padding:0,
                        fontSize: '15px',
                        mt: 1,
                    })}
                >

                    <i className="fas fa-times crose-icon-mt"></i>

                </IconButton>
               <DialogTitle>
                     <h3 className="modal-title">Delete Confirmation</h3>
                      </DialogTitle>
                <DialogTitle>
       {/* <h3 className="modal-title"> Confirm Delete</h3> */}
        </DialogTitle>
                <DialogContent>
                    <div className="delete-card-wapper">
                        <div className="icon-delete-wp">
                            <span className="delete-icon-block"><i className="fas fa-exclamation-triangle"></i></span>
                        </div>
                        <p className="sub-txt-disc" style={{ marginBottom: "7px" }}>Are you sure you want to delete this item ?</p>
                        <p className="sub-txt-disc">This action cannot be undone.</p>
                    </div>
                </DialogContent>

                <Stack direction="row" spacing={2} sx={{ justifyContent: "center", py: 3, textAlign: "center", }} >
                    <Button variant="contained" sx={{ backgroundColor: '#d9d9d9 !important', color: '#626262 !important', borderRadius: '5px', px: 4, py: 1, textTransform: 'capitalize' }}><i className="fas fa-times crose-icon-mt"></i> Cancel</Button>
                    <Button variant="contained" sx={{ backgroundColor: '#2a3fbf !important', borderRadius: '5px', px: 4, py: 1, textTransform: 'capitalize', color: '#FFF !important' }}><i className="far fa-trash-alt delete-icon-mt"></i> Delete</Button>
                </Stack>
            </BootstrapDialog>
        </>

    );
};

export default InnoflexSaveModal;
